import Vue from 'vue';
import { v4 } from 'uuid';

interface Notificaton {
  text: string;
  type: 'notification' | 'success' | 'error';
  id: string;
}

class Store<S> {
  private instance: Vue

  constructor() {
    this.instance = new Vue({
      data: {
        notifications: [],
      },
    });
  }

  get state(): S {
    return (this.instance.$data as any) as S;
  }

  get notifications(): Array<any> {
    return this.instance.$data.notifications;
  }

  addNotification = (text: string) => {
    this.instance.$data.notifications.push({
      type: 'notification',
      text: text,
      id: v4(),
    });
  }

  addErrorNotification = (text: string) => {
    this.instance.$data.notifications.push(
      {
        type: 'error',
        text: text,
        id: v4(),
      },
    );
  }

  addSuccessNotification = (text: string) => {
    this.instance.$data.notifications.push({
      type: 'success',
      text: text,
      id: v4(),
    });
  }

  removeNotificationItem = (targetId: string) => {
    this.instance.$data.notifications = this.instance.$data.notifications.filter((item: Notificaton) => item.id !== targetId);
  }
}

export interface State {
  notifications: any[];
}

class NotificationsStore extends Store<State> {}
export default NotificationsStore;
